module.exports = __webpack_public_path__ + "static/media/stamp_duplicate_black.a4e71b09.png";